import { SkillCategory } from '../types';

export const skillCategories: SkillCategory[] = [
  {
    id: 'languages',
    name: 'skills.categories.languages',
    skills: [
      { name: 'C/C++', level: 90 },
      { name: 'Rust', level: 80 },
      { name: 'Go', level: 85 },
      { name: 'Python', level: 75 },
      { name: 'Assembly (x86/ARM)', level: 70 },
    ],
  },
  {
    id: 'embedded',
    name: 'skills.categories.embedded',
    skills: [
      { name: 'ESP32', level: 90 },
      { name: 'nRF52840', level: 85 },
      { name: 'Zephyr RTOS', level: 85 },
      { name: 'Yocto/Linux', level: 75 },
      { name: 'NFC/RFID', level: 80 },
    ],
  },
  {
    id: 'security',
    name: 'skills.categories.security',
    skills: [
      { name: 'Reverse Engineering', level: 75 },
      { name: 'Network Analysis', level: 80 },
      { name: 'Binary Exploitation', level: 70 },
      { name: 'Protocol Analysis', level: 75 },
    ],
  },
  {
    id: 'tools',
    name: 'skills.categories.tools',
    skills: [
      { name: 'Git', level: 90 },
      { name: 'Docker', level: 80 },
      { name: 'Linux', level: 85 },
      { name: 'GDB/LLDB', level: 75 },
      { name: 'Wireshark', level: 80 },
    ],
  },
];
